var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobilerecharge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.495,
    height: 36.064,
    viewBox: "0 0 27.495 36.064",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke-miterlimit:10;stroke-width:2px;}.a{stroke:#4f4f4f;stroke-linecap:round;}.b{stroke:#40b895;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.009 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M141.86,92.974V84.02A4.032,4.032,0,0,1,145.885,80h13.667a4.032,4.032,0,0,1,4.02,4.02v26.023a4.032,4.032,0,0,1-4.02,4.02H145.885a4.032,4.032,0,0,1-4.02-4.02v-2.322",
    transform: "translate(-138.086 -80)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 8.442,
    transform: "translate(7.523 3.29)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 1.507,
    transform: "translate(18.954 3.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M120.394,191.365a8.875,8.875,0,1,0,3.377,5.835l2.111,1.954",
    transform: "translate(-106.102 -177.961)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M162.264,239.042s.25-1.39-1.44-1.606-2.188,1.414-1.3,3.011,2.893,3.135,1.015,4.613-3.216-1.663-3.755-2.9",
    transform: "translate(-151.431 -220.802)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 0.322,
    y2: 1.525,
    transform: "translate(9.393 15.108)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 0.322,
    y2: 1.525,
    transform: "translate(7.378 24.742)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilerecharge);
export default __webpack_public_path__ + "static/media/mobilerecharge.5396f88e0f770563a060d83c985f5efc.svg";
export { ForwardRef as ReactComponent };